'use client';

import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';

import {
  ChartConfig,
  ChartContainer,
  ChartTooltip,
  ChartTooltipContent,
} from '@/components/ui/chart';

import dayjs from 'dayjs';
import { ChartDataItem } from './ActivityTable.tsx/util';

type Props = {
  chartData: ChartDataItem[];
  chartConfig: ChartConfig;
  startTime: number;
  latestTime: number;
};
export function BarChartTotal({
  chartConfig,
  chartData,
  latestTime,
  startTime,
}: Props) {
  // const startTime = latestTime - 24 * 60 * 60 * 1000;
  const xDomain = [startTime, latestTime];

  return (
    <ChartContainer config={chartConfig} className="max-h-[300px] w-full">
      <BarChart
        accessibilityLayer
        data={chartData}
        margin={{
          left: 12,
          right: 12,
        }}
      >
        <CartesianGrid vertical={false} />
        <XAxis
          dataKey="date"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          minTickGap={32}
          tickFormatter={(value) => dayjs.unix(value).format('DD MMM')}
          scale={'time'}
          name="hour"
          domain={xDomain}
          type="number"
          ticks={[
            startTime,
            // ...chartData.map((item) => item.date),
            latestTime,
          ]}
        />
        <YAxis tickLine={false} axisLine={false} tickMargin={8} tickCount={3} />
        <ChartTooltip
          content={
            <ChartTooltipContent
              className="w-[150px]"
              nameKey="value"
              labelFormatter={(_, payload) => {
                return dayjs.unix(payload[0]?.payload.date).format('DD MMM');
              }}
            />
          }
        />
        {Object.entries(chartConfig).map(([key, config]) => (
          <Bar
            key={key}
            stackId="a"
            dataKey={config.label?.toString() || ''}
            type="monotone"
            fill={config.color}
            maxBarSize={16}
            // strokeWidth={2}
            // dot={false}
          />
        ))}
      </BarChart>
    </ChartContainer>
  );
}

export default BarChartTotal;
